import type { StatColumn } from '../types'

/** Stat abbr → full stat name (e.g. `PTS/G` → `Points Per Game`). */
export const buildStatNames = (columns: StatColumn[]): Record<string, string> =>
  Object.fromEntries(columns.map(({ abbr, name }) => [abbr, name]))

/** The full name for `abbr`, or the abbr itself when no name is known. */
export const getStatName = (
  names: Record<string, string>,
  abbr: string
): string => names[abbr] || abbr
